export const createOrganizationsRequests = (client) => ({
    listOrganizations: async (params) => {
        const { data, meta, links } = await client.api.get("organizations", {
            params: params,
        });
        return { data, meta, links };
    },
    findOrganization: async (params) => {
        const { data } = await client.api.get(`organizations/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createOrganization: async (payload) => {
        const { data } = await client.api.create("organizations", payload);
        return { data };
    },
    updateOrganization: async (payload) => {
        const { data } = await client.api.update("organizations", payload);
        return { data };
    },
});
//# sourceMappingURL=index.js.map